import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#2d6a4f",
    },
    secondary: {
      main: "#4caf50",
    },
    background: {
      // Must be rgba/# — not the keyword `transparent`. DataGrid overlays call alpha() on this value.
      default: "rgba(255, 255, 255, 0)",
      paper: "rgba(255, 255, 255, 0.55)",
    },
    text: {
      primary: "rgba(0, 0, 0, 0.88)",
      secondary: "rgba(0, 0, 0, 0.55)",
    },
  },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"SF Pro Text"',
      '"Segoe UI"',
      "Roboto",
      "Helvetica Neue",
      "Arial",
      "sans-serif",
    ].join(","),
    h5: { fontWeight: 600, letterSpacing: "-0.02em" },
    h6: { fontWeight: 600, letterSpacing: "-0.01em" },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: {
    borderRadius: 16,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          padding: "10px 22px",
          boxShadow: "none",
        },
        contained: {
          background: "linear-gradient(180deg, rgba(255,255,255,0.22) 0%, transparent 100%), #2d6a4f",
          boxShadow: "0 4px 14px rgba(45, 106, 79, 0.35)",
          "&:hover": {
            boxShadow: "0 6px 20px rgba(45, 106, 79, 0.42)",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          backdropFilter: "blur(24px) saturate(180%)",
          WebkitBackdropFilter: "blur(24px) saturate(180%)",
          border: "1px solid rgba(255, 255, 255, 0.65)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.06), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
        },
      },
    },
  },
});

export default theme;
